import { useEffect, useState } from "react";
import { BsFillUnlockFill, BsPencilSquare, BsPersonLinesFill, BsCartCheckFill, BsBoxSeamFill, BsFillHandbagFill } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import ChangePassword from '../../../components/admin/user/change-password'
import commonObj from '../../../utils/Common';

import {
  useAuthContext,
  useCartContext,
  useWishlistContext,
} from "../../contexts";
const UserInfo = (props) => {
  const { token, userInfo, logoutHandler } = useAuthContext();
  const navigate = useNavigate();
  //console.log(props);
  return (
    <div className="absolute right-0 z-10 mt-5  bg-amber-50 font-semibold   rounded-lg shadow w-max  overflow-hidden transition-all">
      <ul className="text-sm  sub_menu">

        <li onClick={() => navigate("/user/profile")}>
          <span className="flex items-center ant-btn font-normal css-dev-only-do-not-override-12upa3x ant-btn-text">
            <BsPersonLinesFill className="text-md me-3" /> {commonObj.getLabel('Profile')}  <span> ({(userInfo?.userType==4)? commonObj.getLabel('Buyer') : commonObj.getLabel('Seller')})</span>
          </span>
        </li>
        <li onClick={() => navigate("/user/myproposals")}>
          <span className="flex items-center font-normal ant-btn css-dev-only-do-not-override-12upa3x ant-btn-text ">
            <BsFillHandbagFill className="text-md me-3" /> {commonObj.getLabel('My_Proposals')}
          </span>
        </li>
        <li onClick={() => navigate("/user/myproducts")}>
          <span className="flex items-center font-normal ant-btn css-dev-only-do-not-override-12upa3x ant-btn-text ">
            <BsBoxSeamFill className="text-md me-3" /> {commonObj.getLabel('My_Products')}
          </span>
        </li>
        <li onClick={() => navigate("/user/myorders")}>
          <span className="flex items-center font-normal ant-btn css-dev-only-do-not-override-12upa3x ant-btn-text ">
            <BsCartCheckFill className="text-md me-3" /> {commonObj.getLabel('My_Orders')}
          </span>
        </li>
        <li>
        <span className="flex items-center ">
            <ChangePassword id={userInfo?.id} name="Change Password" top="10"  />
            </span>
        </li>
        <li onClick={() =>props.logout() }>
          <span className="flex items-center ant-btn css-dev-only-do-not-override-12upa3x ant-btn-text">
           <BsFillUnlockFill className="text-md me-3" /> {commonObj.getLabel('Logout')}
          </span>
        </li>        
      </ul>
    </div>
  );
};

export default UserInfo;
